import { wirelessBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.config';
import { RouteBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.model';

export const portInBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [
    wirelessBreadcrumbsConfig,
    {
      alt: '',
      copy: 'transfer-phone-number.header',
      val: null,
    },
  ],
  regexp: /^transfer-phone-number(.+)?/,
  useRegEx: true,
  key: 'transfer-phone-number',
};
